import { render, staticRenderFns } from "./AdminDashboardCompetitions.vue?vue&type=template&id=47b5b854&"
import script from "./AdminDashboardCompetitions.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardCompetitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports